import { createAction, props } from '@ngrx/store';

// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nx/enforce-module-boundaries
import { User } from '@cigna/chcp/working-with-cigna/manage-access-feature';
import {
  ServiceError,
  Message,
  MessageUpdate,
  MessageFilters,
} from '@cigna/chcp/shared/util';

export const loadLatestUpdates = createAction(
  '[Dashboard] Load Recent Updates',
);
export const loadLatestUpdatesSuccess = createAction(
  '[Dashboard] Load Recent Updates Success',
  props<{ updates: any[] }>(),
);
export const loadLatestUpdatesError = createAction(
  '[Dashboard] Load Recent Updates Error',
);

export const resetManageAccessTile = createAction(
  '[Dashboard] Manage Access Reset Tile',
);

export const loadManageAccessUsers = createAction(
  '[Dashboard] Load Manage Access Users',
);
export const loadManageAccessUsersSuccess = createAction(
  '[Dashboard] Load Manage Access Users Success',
  props<{ users: User[] }>(),
);
export const loadManageAccessUsersError = createAction(
  '[Dashboard] Load Manage Access Users Error',
);

export const loadManageAccessUserDetail = createAction(
  '[Dashboard] Load Manage Access User Detail',
  props<{ user: User }>(),
);
export const loadManageAccessUserDetailSuccess = createAction(
  '[Dashboard] Load Manage Access User Detail Success',
  props<{ user: User }>(),
);
export const loadManageAccessUserDetailError = createAction(
  '[Dashboard] Load Manage Access User Detail Error',
);
export const fetchMessages = createAction(
  '[Dashboard] Fetch Messages',
  props<{ filters: MessageFilters }>(),
);
export const fetchMessagesSuccess = createAction(
  '[Dashboard] Fetch Messages Success',
  props<{ messages: Message[] }>(),
);
export const fetchMessagesError = createAction(
  '[Dashboard] Fetch Messages Error',
  props<{ error: ServiceError }>(),
);
